import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    width: 100%;
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    background: linear-gradient(135deg, #4c1d95 0%, #2e1065 100%);
    overflow-y: auto;
    position: relative;
  }

  #root {
    min-height: 100vh;
    width: 100%;
  }

  button {
    font-family: 'Roboto', sans-serif;
  }

  // Estilos para SweetAlert
  .swal-popup {
    border-radius: 16px !important;
    padding: 2rem !important;
  }

  .swal-title {
    color: #2d3748 !important;
    font-size: 1.5rem !important;
    font-weight: 600 !important;
  }

  .swal-text {
    color: #4a5568 !important;
    font-size: 1rem !important;
  }

  .swal-confirm {
    border-radius: 20px !important;
    padding: 0.75rem 1.5rem !important;
    font-weight: 500 !important;
    text-transform: none !important;
    background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%) !important;
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.2) !important;

    &:hover {
      transform: translateY(-1px) !important;
      box-shadow: 0 6px 16px rgba(124, 58, 237, 0.3) !important;
    }
  }

  .swal-cancel {
    border-radius: 20px !important;
    padding: 0.75rem 1.5rem !important;
    font-weight: 500 !important;
    text-transform: none !important;
    background: #f1f5f9 !important;
    color: #64748b !important;
    box-shadow: none !important;

    &:hover {
      background: #e2e8f0 !important;
    }
  }

  .prize-modal-popup {
    border-radius: 20px !important;
    border: 1px solid rgba(255, 215, 0, 0.2) !important;
    padding: 2rem !important;
  }

  .prize-modal-content {
    color: #ffd700;
    text-align: center;
  }

  .prize-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
    animation: bounce 1s ease infinite;
  }

  .prize-text {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 1rem 0;
    background: linear-gradient(135deg, #ffd700 0%, #ffb347 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(255, 215, 0, 0.3);
  }

  .prize-subtitle {
    color: rgba(255, 215, 0, 0.8);
    font-size: 1.1rem;
    margin-top: 0.5rem;
  }

  .prize-modal-button {
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(255, 179, 71, 0.2) 100%) !important;
    border: 1px solid rgba(255, 215, 0, 0.3) !important;
    color: #ffd700 !important;
    border-radius: 20px !important;
    padding: 1rem 2rem !important;
    font-size: 1.1rem !important;
    font-weight: 500 !important;
    letter-spacing: 0.5px !important;
    transition: all 0.3s ease !important;

    &:hover {
      background: linear-gradient(135deg, rgba(255, 215, 0, 0.3) 0%, rgba(255, 179, 71, 0.3) 100%) !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
    }
  }

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
`;

export default GlobalStyles;